import React from 'react';
import {
  withStyles,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  // DialogActions,
  FormHelperText,
  Typography,
  TextField,
} from '@material-ui/core';
import { withTranslation } from 'react-i18next';
// import InputAddress from 'react-thailand-address-autocomplete';
import ThaiAddress from 'react-thai-address';
import IntegrationReactSelect from '../../../../components/Select/Select';

class TenantForm extends React.PureComponent {
  render() {
    const { classes, t } = this.props;

    // get all provinces
    const provinces = ThaiAddress.provinces;
    const provinceList = (provinces || []).map((province) => ({
      label: province,
      value: province,
    }));

    // search by attribute
    const searchByProvince = ThaiAddress.search({
      province: this.props.data.province ? this.props.data.province.label : '',
    });
    const districtList = [...new Set(searchByProvince.map((item) => item.city))].map((district) => ({
      label: district,
      value: district,
    }));

    const searchByCity = ThaiAddress.search({
      city: this.props.data.district ? this.props.data.district.label : '',
    });
    const postCodeList = [...new Set(searchByCity.map((item) => item.zipcode))].map((zipcode) => ({
      label: zipcode,
      value: zipcode,
    }));

    const usageTypeList = [
      {
        label: `${t('hospital')}`,
        value: 'hospital',
      },
      {
        label: `${t('home')}`,
        value: 'home',
      },
    ];

    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.handleCloseForm}
        aria-labelledby='form-dialog-title'
        maxWidth='sm'
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 8,
          },
        }}
      >
        <DialogTitle className='header' id='form-dialog-title'>
          <Grid container style={{ position: 'relative' }}>
            <div className={classes.textHeader}>{t('wizard_tenant_detail')}</div>
            <div id='closeIcon' className='closeIcon' onClick={this.props.handleCloseForm}>
              <svg width='32' height='32' viewBox='0 0 32 32'>
                <use xlinkHref={`/images/menus-v1.svg#close`} />
              </svg>
            </div>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Grid container item md={12} xs={12} alignItems='center'>
            <Grid item md={12} xs={12}>
              <Typography
                style={{
                  fontWeight: 500,
                  fontSize: 18,
                }}
              >
                {t('wizard_tenant_name')}*
              </Typography>
            </Grid>
            <Grid item md={12} xs={12}>
              <TextField
                required
                id='name'
                name='name'
                variant='outlined'
                margin='dense'
                fullWidth
                value={this.props.data.name}
                onChange={(e) => this.props.handleChange(e)}
                className={classes.textField}
                InputProps={{
                  className: classes.input,
                }}
              />
              <FormHelperText error hidden={!this.props.errorField.name.flag} id='component-error-text'>
                {this.props.errorField.name.msg}
              </FormHelperText>
            </Grid>
          </Grid>

          <Grid container item md={12} xs={12} alignItems='center'>
            <Grid item md={12} xs={12}>
              <Typography
                style={{
                  fontWeight: 500,
                  fontSize: 18,
                }}
              >
                {t('province')}
              </Typography>
            </Grid>
            <Grid item md={12} xs={12}>
              <IntegrationReactSelect
                id='province'
                name='province'
                value={this.props.data.province || null}
                options={provinceList}
                handleChange={this.props.handleChangeProvince}
                label=''
                isClearable={true}
              />
            </Grid>
          </Grid>

          <Grid container item md={12} xs={12} alignItems='center'>
            <Grid item md={12} xs={12}>
              <Typography
                style={{
                  fontWeight: 500,
                  fontSize: 18,
                }}
              >
                {t('district')}
              </Typography>
            </Grid>
            <Grid item md={12} xs={12}>
              <IntegrationReactSelect
                id='district'
                name='district'
                value={this.props.data.district || null}
                options={districtList}
                handleChange={this.props.handleChangeDistrict}
                label=''
                maxHeight='200px'
                isClearable={true}
                isDisabled={this.props.data.province ? false : true}
              />
            </Grid>
          </Grid>

          <Grid container item md={12} xs={12} alignItems='center'>
            <Grid item md={12} xs={12}>
              <Typography
                style={{
                  fontWeight: 500,
                  fontSize: 18,
                }}
              >
                {t('postcode')}
              </Typography>
            </Grid>
            <Grid item md={12} xs={12}>
              <IntegrationReactSelect
                id='postcode'
                name='postcode'
                value={this.props.data.postcode || null}
                options={postCodeList}
                handleChange={this.props.handleChangePostCode}
                label=''
                maxHeight='100px'
                isClearable={true}
                isDisabled={this.props.data.district ? false : true}
              />
            </Grid>
          </Grid>

          <Grid container item md={12} xs={12} alignItems='center'>
            <Grid item md={12} xs={12}>
              <Typography
                style={{
                  fontWeight: 500,
                  fontSize: 18,
                }}
              >
                {t('address')}
              </Typography>
            </Grid>
            <Grid item md={12} xs={12}>
              <TextField
                variant='outlined'
                margin='dense'
                fullWidth
                id='address'
                name='address'
                value={this.props.data.address || ''}
                onChange={(e) => this.props.handleChange(e)}
                className={classes.textField}
                InputProps={{
                  className: classes.input,
                }}
              />
            </Grid>
          </Grid>

          <Grid container item md={12} xs={12} alignItems='center'>
            <Grid item md={12} xs={12}>
              <Typography
                style={{
                  fontWeight: 500,
                  fontSize: 18,
                }}
              >
                {t('usage_type')}
              </Typography>
            </Grid>
            <Grid item md={12} xs={12}>
              <IntegrationReactSelect
                id='usageType'
                name='usageType'
                value={this.props.data.usageType || null}
                options={usageTypeList}
                handleChange={this.props.handleChangeUsageType}
                label=''
                maxHeight='100px'
                isClearable={true}
              />
            </Grid>
          </Grid>

          <Grid container style={{ margin: '40px 0px 10px', justifyContent: 'right' }}>
            <Button
              id='save'
              variant='contained'
              color='primary'
              className={classes.btnPrimary}
              onClick={this.props.handleSubmitForm}
            >
              {t('save')}
            </Button>
          </Grid>
        </DialogContent>
      </Dialog>
    );
  }
}

const styles = (theme) => ({
  textHeader: {
    display: 'flex',
    justifyContent: 'center',
    color: theme.palette.text.header,
    fontWeight: 500,
    fontSize: 30,
  },
  wrapButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right',
  },
  btnPrimary: {
    width: 200,
    borderRadius: '4px',
  },
  textField: {
    fontWeight: 400,
  },
  input: {
    color: theme.palette.text.primary,
    height: 40,
  },
  formControl: {
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, 10px) scale(1)',
    },
    margin: theme.spacing.unit / 2,
    width: '100%',
  },
  contentSelect: {
    display: 'flex',
    '& fieldset': {
      top: '2px',
    },
    '& svg': {
      top: 'calc(58% - 8px)',
    },
    '& select': {
      paddingTop: '17px',
      paddingBottom: '9px',
    },
  },
  iconSelect: {
    position: 'absolute',
    backgroundColor: 'transparent !important',
    display: 'flex',
    marginBottom: '10px',
    top: 'calc(58% - 3px)',
    right: 'calc(10% - 14px)',
  },
});

// export const page = inject("wizard")(observer(MainOrganizationForm));
export const translation = withTranslation()(TenantForm);
export default withStyles(styles, { withTheme: true })(translation);
